'use client'

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface RevenueData {
  month: string
  revenue: number
}

interface RevenueChartProps {
  data: RevenueData[]
}

export default function RevenueChart({ data }: RevenueChartProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(value)
  }

  return (
    <div className="bg-white dark:bg-charcoal-900 rounded-xl p-6 border border-charcoal-200 dark:border-charcoal-800">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-charcoal-900 dark:text-white mb-2">
          Revenue Over Time
        </h3>
        <p className="text-sm text-charcoal-600 dark:text-charcoal-400">
          Monthly revenue from course enrollments
        </p>
      </div>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
            <XAxis 
              dataKey="month" 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'currentColor' }}
              tickFormatter={formatCurrency}
            />
            <Tooltip 
              formatter={(value: number) => [formatCurrency(value), 'Revenue']}
              labelStyle={{ color: 'var(--charcoal-900)' }}
              contentStyle={{
                backgroundColor: 'var(--white)',
                border: '1px solid var(--charcoal-200)',
                borderRadius: '8px',
              }}
            />
            <Line 
              type="monotone" 
              dataKey="revenue" 
              stroke="#c9a961" 
              strokeWidth={3}
              dot={{ fill: '#c9a961', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: '#c9a961', strokeWidth: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
